import { useEffect, useState } from "react";
import styles from "./scan-contacts.module.scss";
import moment from "moment";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Popover } from "react-bootstrap";
import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import { handleCopy } from "@helpers/profileHelper";
import axios from "axios";
import { profileTypeEndPoint } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import commaFormat from "@utils/commaFormat";
import Call from "@assets/images/call.svg";
import Expand from "@assets/images/expand.svg";
import Location from "@assets/images/location.svg";
import Refresh from "@assets/images/refresh.svg";
import Download from "@assets/images/download.svg";
import Email from "@assets/images/email.svg";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { contactScanDataHandler } from "@redux/ProfileContacts/profileContactsSlice";
import DynamicGenerator from "@utils/dynamicTextGenerator";
import { getApiUrl } from "@utils/baseUrl";
import { captureException } from "@sentry/react";

let DATA_ICON = {
  phone: Call,
  address: Location,
  email: Email,
};

const ScanContacts = ({ dataSource, pathName, currentUserPlan }) => {
  const [contactsData, setContactsData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isGenerating, setIsGenerating] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { logisticsProfile, companyProfile } = useSelector((state) => state);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [selectedPhones, setSelectedPhones] = useState([]);
  const [isFirstCall, setIsFirstCall] = useState(true);
  const dispatch = useDispatch();
  const { profileContactData } = useSelector((state) => state);

  const getContactsData = () => {
    let payload = {
      company_id: companyProfile?.countDetails?.elastic_data_id?.[0] || logisticsProfile?.countDetails?.elastic_data_id?.[0] || "",
      from: (currentPage - 1) * 10,
    };
    if (isFirstCall) setIsFirstCall(false);
    axios
      .post(profileTypeEndPoint.getContactScaningData, payload)
      .then((res) => {
        if (payload.from !== 0) {
          let tempContactData = JSON.parse(JSON.stringify(contactsData));
          tempContactData.email = [...tempContactData.email, ...res.data.data.email];
          tempContactData.phone = [...tempContactData.phone, ...res.data.data.phone];
          setContactsData(JSON.parse(JSON.stringify(tempContactData)));
        } else {
          dispatch(contactScanDataHandler(JSON.parse(JSON.stringify(res.data.data))));
          setContactsData(JSON.parse(JSON.stringify(res.data.data)));
        }
      })
      .catch(() => toast.error("Something went wrong. Please try again!"))
      .finally(() => setIsLoading(false));
  };

  const downloadContacts = () => {
    const selectedContacts = [];
    selectedEmails.forEach((email) => {
      const data = contactsData.email.find((e) => e.email === email);
      selectedContacts.push({
        name: data.contact,
        email: email,
        contact_type: "email",
        company_name: companyProfile?.countDetails?.name || "",
        shipment_count: data?.shipment_count ?? "",
        latest_date: data?.latest_date ?? "",
      });
    });
    selectedPhones.forEach((phone) => {
      const data = contactsData.phone.find((e) => e.phone === phone);
      selectedContacts.push({
        name: data.contact,
        phone: phone,
        contact_type: "phone",
        company_name: companyProfile?.countDetails?.name || "",
        shipment_count: data?.shipment_count ?? "",
        latest_date: data?.latest_date ?? "",
      });
    });
    let file_name = "CompanyShipmentContacts_" + moment().format("DD-MM-YYYY") + "_" + new Date().getTime() + ".xlsx";
    const requestObject = {
      company_id: companyProfile?.countDetails?.elastic_data_id?.[0] || logisticsProfile?.countDetails?.elastic_data_id?.[0] || "",
      is_all_contact: selectedContacts.length > 0 ? false : true,
      file_name: file_name,
      company_name: companyProfile?.countDetails?.name || "",
    };
    if (selectedContacts.length > 0) requestObject.data = selectedContacts;
    axios
      .post(profileTypeEndPoint.downloadContacts, requestObject, {
        responseType: "blob",
      })
      .then((response) => {
        const contentTypeHeader = response.headers["content-type"];
        const file = new Blob([response.data], { type: contentTypeHeader });
        const url = window.URL.createObjectURL(file);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = file_name;
        a.click();
      })
      .catch((err) => {
        captureException(err);
        toast.error("Something went wrong, Please try after sometime !!!");
      });
  };
  const addToContacts = async () => {
    try {
      const selectedContacts = [];
      selectedEmails.forEach((email) => {
        const data = contactsData.email.find((e) => e.email === email);
        selectedContacts.push({
          name: data?.contact ?? "",
          email: email,
          contact_type: "email",
          company_name: companyProfile?.countDetails?.name || "",
        });
      });
      selectedPhones.forEach((phone) => {
        const data = contactsData.phone.find((e) => e.phone === phone);
        selectedContacts.push({
          name: data?.contact ?? "",
          phone: phone,
          contact_type: "phone",
          company_name: companyProfile?.countDetails?.name || "",
        });
      });
      const requestObject = {
        company_id: companyProfile?.countDetails?.elastic_data_id?.[0] || logisticsProfile?.countDetails?.elastic_data_id?.[0] || "",
        is_all_contact: selectedContacts.length > 0 ? false : true,
        company_name: companyProfile?.countDetails?.name || "",
      };
      if (selectedContacts.length > 0) requestObject.data = selectedContacts;
      const res = await axios.post(getApiUrl("addFavouriteAIContact"), requestObject);
      toast.success(res?.data?.message || "Contact added to your viewed contacts successfully");
    } catch (error) {
      toast.error("Something went wrong, Please try after sometime !!!");
    }
  };
  useEffect(() => {
    if (profileContactData?.contactScanData && Object.keys(profileContactData.contactScanData).length > 0 && currentPage === 1) {
      setContactsData(JSON.parse(JSON.stringify(profileContactData.contactScanData)));
      setIsLoading(false);
      setIsFirstCall(true);
    } else {
      getContactsData();
    }
  }, [currentPage]);

  if (isLoading) {
    return (
      <div className={`d-flex flex-column align-items-center justify-content-center ${styles.loader_parent}`}>
        <img height={200} width={200} src={CLOUDINARY_INTEL_BASE_URL + "/v1715582998/intel/icons/Document_Search_mnkq9h.gif"} alt="Searching..." />
        <div>Our AI model is scanning shipments for the contacts.</div>
        <div>The contacts would be published here if found in the shipments.</div>
      </div>
    );
  }

  return (
    <div className="my-2">
      <div className="d-flex">
        <button
          onClick={() => {
            downloadContacts("");
            trademoTrackingEvents(trackingEventDictionary.companyProfileContactDetailsScanShipmentsTabDownload, generateTrackingObject(dataSource, pathName, currentUserPlan));
          }}
          className={`${styles.download_button}`}>
          <img className="mr-1" src={Download} alt="Download" />
          Download
        </button>
        <button
          onClick={() => {
            addToContacts();
            trademoTrackingEvents(trackingEventDictionary.companyProfileContactDetailsScanShipmentsAddToContactList, generateTrackingObject(dataSource, pathName, currentUserPlan));
          }}
          className={`${styles.download_button}`}>
          <span className="material-symbols-outlined mr-1">contacts</span>
          Add to Viewed Contacts
        </button>
      </div>
      <div className={`d-flex w-100 ${styles.scan_contact_container}`}>
        {contactsData.phone_count > 0 ? (
          <div className={`${styles.section_container} w-50`}>
            <div className={`d-flex justify-content-between align-items-center ${styles.section_header}`}>
              <div>
                <img className="mr-1" src={Call} alt="call" />
                {`${commaFormat(contactsData.phone_count)} Phone Number${contactsData.phone_count > 1 ? "s" : ""} found`}
              </div>
              <div></div>
            </div>
            <SectionTable
              setIsGenerating={(e) => {
                if (e !== isGenerating) {
                  setIsGenerating(e);
                }
              }}
              isFirstCall={isFirstCall}
              loadMore={() => setCurrentPage(currentPage + 1)}
              keyName="phone"
              count={contactsData.phone_count}
              data={contactsData.phone}
              companyId={companyProfile?.countDetails?.elastic_data_id?.[0] || logisticsProfile?.countDetails?.elastic_data_id?.[0] || ""}
              setSelectedPhones={setSelectedPhones}
              selectedPhones={selectedPhones}
            />
          </div>
        ) : (
          <></>
        )}
        {contactsData.email_count > 0 ? (
          <div className={`${styles.section_container} w-50`}>
            <div className={`d-flex justify-content-between align-items-center ${styles.section_header}`}>
              <div>
                <img className="mr-1" src={Email} alt="Email" />
                {`${commaFormat(contactsData.email_count)} Email Address${contactsData.email_count > 1 ? "es" : ""} found`}
              </div>
            </div>
            <div>
              <SectionTable
                setIsGenerating={(e) => {
                  if (e !== isGenerating) {
                    setIsGenerating(e);
                  }
                }}
                isFirstCall={isFirstCall}
                dataSource={dataSource}
                pathName={pathName}
                currentUserPlan={currentUserPlan}
                loadMore={() => setCurrentPage(currentPage + 1)}
                keyName="email"
                count={contactsData.email_count}
                data={contactsData.email}
                companyId={companyProfile?.countDetails?.elastic_data_id?.[0] || logisticsProfile?.countDetails?.elastic_data_id?.[0] || ""}
                selectedEmails={selectedEmails}
                setSelectedEmails={setSelectedEmails}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ScanContacts;

const SectionTable = ({ isFirstCall, dataSource, pathName, currentUserPlan, setIsGenerating, count, data, keyName, companyId, loadMore, setSelectedEmails, setSelectedPhones }) => {
  const [contactDetails, setContactDetails] = useState([]);
  const [tableData, setTableData] = useState([data[0]]);
  const [currentCount, setCurrentCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [contactCount, setContactCount] = useState(0);
  const [showLoadMore, setShowLoadMore] = useState(true);

  useEffect(() => {
    if (isFirstCall === true) {
      setTableData([...data]);
      setCurrentCount(data.length);
    }
  }, []);
  useEffect(() => {
    setShowLoadMore(true);
    const interval = setInterval(() => {
      // Check if there are more characters to display
      if (tableData.length < data.length) {
        setIsGenerating(true);
        // Add the next character to the displayed text
        setTableData((prevText) => [...prevText, data[currentCount]]);
        setCurrentCount(currentCount + 1);
        const element = document.getElementById("tablelocate" + keyName);
        if (element) {
          element.scrollTop = element.scrollHeight;
        }
      } else {
        setIsGenerating(false);
        clearInterval(interval); // Stop interval once the entire paragraph is displayed
      }
    }, 500); // Adjust the speed of text generation (in milliseconds)

    return () => clearInterval(interval); // Clean up on component unmount
  }, [tableData, data]);
  const getContactDetails = (item, page) => {
    setCurrentPage(page);
    let payload = {
      company_id: companyId,
      from: page ? (page - 1) * 10 : 0,
      type: keyName,
    };
    if (payload.from === 0) {
      setContactDetails([]);
    }
    payload[keyName] = item;
    axios
      .post(profileTypeEndPoint.getContactScaningData, payload)
      .then((res) => {
        if (payload.from !== 0) {
          let tempAddressData = JSON.parse(JSON.stringify(contactDetails));
          tempAddressData = [...tempAddressData, ...res.data.data];
          setContactDetails(JSON.parse(JSON.stringify(tempAddressData)));
        } else {
          setContactCount(res.data.total_count);
          setContactDetails(JSON.parse(JSON.stringify(res.data.data)));
        }
      })
      .catch(() => toast.error("Something went wrong. Please try again!"))
      .finally(() => false);
  };

  const handleCheckboxChange = (e, item) => {
    if (e.target.name === "email") {
      setSelectedEmails((prev) => (prev.includes(item.email) ? prev.filter((e) => e !== item.email) : [...prev, item.email]));
    } else if (e.target.name === "phone") {
      setSelectedPhones((prev) => (prev.includes(item.phone) ? prev.filter((p) => p !== item.phone) : [...prev, item.phone]));
    }
  };
  return (
    <div id={"tablelocate" + keyName} className={`d-flex flex-column ${styles.section_table}`}>
      {tableData.map((item) => {
        return (
          <div key={item[keyName] + item.latest_date} className={`${styles.row_data} d-flex justify-content-between align-items-center`}>
            <div>
              <div className={styles.contact_data}>
                <input type="checkbox" className="form-check-input position-relative mr-2 ml-0" name={keyName} value={item[keyName]} onChange={(e) => handleCheckboxChange(e, item)} />
                <DynamicGenerator stopGenerating={isFirstCall} text={`${item[keyName].toLowerCase()} ${item.contact ? ` (${item.contact}) ` : ""}`} />
                <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1709185641/intel/icons/hdg1qqouwpmldojxnmwh.svg`} className={`cursor-pointer`} onClick={() => handleCopy(`${keyName === "email" ? item[keyName]?.toLowerCase() : item[keyName]} ${item.contact ? ` (${item.contact}) ` : ""}`)} />
              </div>
              <div className={styles.contact_date}>Last found on {moment(item.latest_date).format("MMM DD, YYYY")}</div>
            </div>
            <div className={styles.count_container}>
              <OverlayTrigger
                trigger="click"
                key={"right"}
                placement={"left"}
                rootClose
                overlay={
                  <Popover id={`popover-positioned-right`}>
                    <Popover.Content className={styles.popoverBody}>
                      <DetailedPopup contactCount={contactCount} contactDetails={contactDetails} getContactDetails={() => getContactDetails(item[keyName], currentPage + 1)} />
                    </Popover.Content>
                  </Popover>
                }>
                <div
                  onClick={() => {
                    trademoTrackingEvents(trackingEventDictionary.companyProfileScanShipmentViewAddress, generateTrackingObject(dataSource, pathName, currentUserPlan));
                    getContactDetails(item[keyName], 1);
                  }}
                  className={`d-flex align-items-center cursor-pointer ${styles.contact_count}`}>
                  <img className="mr-1" src={Expand} alt="Expand" />
                  {`${commaFormat(item.shipment_count)} occurrence${item.shipment_count > 1 ? "s" : ""}`}
                </div>
              </OverlayTrigger>
            </div>
          </div>
        );
      })}
      {count > data.length && tableData.length === data.length && showLoadMore ? (
        <div className={`${styles.load_more}`}>
          <span
            onClick={() => {
              setShowLoadMore(false);
              loadMore();
            }}
            className="cursor-pointer">
            Load more
            <img src={Refresh} alt="call" />
          </span>
        </div>
      ) : count !== tableData.length ? (
        <div className={styles.tablelocateLoad}></div>
      ) : (
        <></>
      )}
    </div>
  );
};

const DetailedPopup = ({ contactDetails, contactCount, getContactDetails }) => {
  const [showLoadMore, setShowLoadMore] = useState(true);
  useEffect(() => {
    setShowLoadMore(true);
  }, [contactDetails]);
  return (
    <div className={`${styles.address_modal}`}>
      <div className={`${styles.address_header}`}>Below are the addresses where we found the contacts</div>
      <div className={`d-flex flex-column ${styles.address_container}`}>
        {contactDetails.map((contact, index) => {
          return (
            <div key={contact?.label} className={`${styles.address_row}`}>
              <div className={`${styles.address_row_header} d-flex align-items-center`}>
                <img className="mr-1" src={DATA_ICON[contact?.type]} alt="call" />
                <span className="text-capitalize mr-1">{contact?.type}</span>
                {index + 1}
                {contact?.count ? ` - found in ${contact?.count} shipment${contact?.count > 1 ? "s" : ""}` : ""}
              </div>
              <div className={`${styles.address_row_body}`}>
                {contact?.label.slice(0, contact?.span?.[0])} <span className={`${styles.highlight_text}`}>{contact?.label.slice(contact?.span?.[0], contact?.span?.[1])}</span> {contact?.label.slice(contact?.span?.[1])}
              </div>
            </div>
          );
        })}
        {contactCount > contactDetails.length && contactDetails.length > 0 && showLoadMore ? (
          <div className={`${styles.load_more}`}>
            <span
              onClick={() => {
                setShowLoadMore(false);
                getContactDetails();
              }}
              className="cursor-pointer">
              Load more
              <img src={Refresh} alt="call" />
            </span>
          </div>
        ) : (
          <></>
        )}
        {contactDetails.length === 0 ? <LoadingSkeleton lines={2} lineHeight="96px" width="100%" shape="rectangle" /> : <></>}
      </div>
    </div>
  );
};
